module.exports = __webpack_public_path__ + "img/tileable-beam-END.af0127c1.png";